import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';

import { AppError } from '@vk-hr-tek/core/error';

import { RequestStatus } from '@app/types';
import { RootState } from '@app/store';
import { BellNotification } from '@app/gen/bell';

interface InitialState extends EntityState<BellNotification, string> {
  status: RequestStatus;
  error: AppError | null;
  currentLastNotificationId: string | null;
  unreadNotificationsCount: number | null;
  hasMoreNotifications: boolean;
  isMarkReadAllPending: boolean;
  isGetUnreadNotificationsCounterPending: boolean;
}
const initState: InitialState = {
  status: 'idle' as const,
  error: null,
  currentLastNotificationId: null,
  unreadNotificationsCount: null,
  hasMoreNotifications: false,
  isMarkReadAllPending: false,
  isGetUnreadNotificationsCounterPending: false,
  ids: [],
  entities: {},
};

export interface BellNotificationsState {
  page: InitialState;
  bell: InitialState;
}

export const bellNotificationsAdapter = createEntityAdapter<BellNotification>();
export const pageNotificationsAdapter = createEntityAdapter<BellNotification>();

export const initialState: BellNotificationsState = {
  page: pageNotificationsAdapter.getInitialState(initState),
  bell: bellNotificationsAdapter.getInitialState(initState),
};

export interface BellNotificationsWithRootState extends RootState {
  bellNotifications: BellNotificationsState;
}
